import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DateRangeFieldComponent } from './date-range-field.component';

export * from './date-range-field.component';

@NgModule({
  declarations: [DateRangeFieldComponent],
  exports: [DateRangeFieldComponent],
  imports: [CommonModule, MatFormFieldModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule]
})
export class DateRangeFieldModule {}
